import { JSX } from 'react';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface Props {
  text: string;
  required?: boolean;
  sx?: SxProps<Theme>;
}

export default function QuestionText({
  text,
  required,
  sx,
}: Props): JSX.Element {
  return (
    // `key={text}` forces a remount when the question text changes. Without it,
    // Google Translate wraps the bare text node in a <font> element and React's
    // subsequent text update targets the detached node, leaving stale text on
    // screen while navigation advances to a different question.
    <Typography key={text} sx={{ fontSize: 20, fontWeight: 700, ...sx }}>
      {text}
      {required && (
        <Typography
          component="span"
          sx={{
            fontSize: 16,
            fontWeight: 700,
            color: 'error.main',
            lineHeight: 1.4,
            ml: 0.5,
          }}
          aria-hidden="true"
        >
          *
        </Typography>
      )}
    </Typography>
  );
}
